import { Text, List, ListItem, Button, Card } from '@chakra-ui/react';

import Colors from '../../../../config/colors';
import truncate from '../../../../utils/truncate';
import { ISupportMessage } from '../../../../interfaces';
import { useActions } from '../../../../hooks/actions';
import SupportStatus from './supportStatus/SupportStatus';
import { useTranslation } from 'react-i18next';

interface Props {
    supportMessage: ISupportMessage;
}

export default function SupportMessageItem({ supportMessage }: Props) {
    const { setSupportMessageShowModal } = useActions();
    const [t] = useTranslation();

    const showMessage = () => {
        setSupportMessageShowModal({ supportMessage });
    };

    return (
        <Card
            direction={{ base: 'column', sm: 'row' }}
            overflow="hidden"
            variant="unstyled"
            padding="15px"
            boxShadow="rgba(68, 98, 136, 0.25) 0px 3px 12px"
            borderRadius="0px"
            fontWeight="500"
            fontSize="14px"
            backgroundImage={process.env.PUBLIC_URL + '/images/categories/background_spotlight.jpg'}
            backgroundSize="cover">
            <List spacing={3} width="100%">
                <ListItem display="flex" justifyContent="space-between">
                    <SupportStatus supportStatus={supportMessage.supportStatus} />
                </ListItem>
                <ListItem>
                    <Text color={Colors.lightBlue} fontSize="12px">
                        {t('message')}
                    </Text>
                    <Text color="#fff">{truncate(supportMessage.message)}</Text>
                </ListItem>
                {supportMessage.replyMessage && (
                    <ListItem>
                        <Text color={Colors.lightBlue} fontSize="12px">
                            {t('answer')}
                        </Text>
                        <Text color="#fff">{supportMessage?.replyMessage}</Text>
                    </ListItem>
                )}
                <ListItem>
                    <Button
                        variant="solid"
                        border="none"
                        fontSize="14px"
                        fontWeight="500"
                        display="flex"
                        alignItems="center"
                        gap="12px"
                        width="100%"
                        onClick={showMessage}
                        background="#fff">
                        <Text>{t('show-message')}</Text>
                    </Button>
                </ListItem>
            </List>
        </Card>
    );
}
